/**
 * Read-only rule preview - groups with colored tags (for tooltips)
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { listRuleToGroups } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

export interface RulePreviewProps {
  listRule: Record<string, unknown> | null | undefined;
  tagColors?: Record<string, string>;
}

export const RulePreview: FC<RulePreviewProps> = ({ listRule, tagColors }) => {
  const groups = listRuleToGroups(listRule);
  if (groups.length === 0) return <span className="text-xs text-muted-foreground">Rule-based preset</span>;

  return (
    <div className="flex flex-col gap-2 p-2">
      {groups.map((tags, i) => (
        <div key={i} className="flex flex-col gap-1.5">
          {i > 0 && (
            <div className="flex items-center gap-2">
              <div className="h-px flex-1 bg-border" />
              <span className="text-xs font-medium text-muted-foreground">and</span>
              <div className="h-px flex-1 bg-border" />
            </div>
          )}
          <div className="rounded-lg border border-border bg-card p-2 shadow-sm">
            <div className="mb-1.5 text-xs font-medium text-muted-foreground">
              Group {i + 1} · any of these tags
            </div>
            <div className="flex flex-wrap gap-1.5">
              {tags.map((tag) => {
                const color = tagColors?.[tag];
                return (
                  <span
                    key={tag}
                    className={cn(
                      'inline-flex rounded-md px-2 py-0.5 text-xs font-medium',
                      color ? 'text-white' : 'bg-muted text-foreground',
                    )}
                    style={color ? { backgroundColor: color } : undefined}
                  >
                    {tag}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
